import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { MultiInputStepComponent } from '../../step/multi-input-step/multi-input-step.component';

@Component({
    selector: 'app-neustar',
    templateUrl: './neustar.component.html',
    styleUrls: ['./neustar.component.scss', '../../step/step.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    standalone: false
})
export class NeustarComponent extends MultiInputStepComponent implements OnInit {
  
  @ViewChild('phone') phoneField: ElementRef;
  
  public experiment: boolean;
  public subtext: string;

  phoneMask: Object = {
    mask: [
      {
        mask: /^$/i,
        lazy: true
      },
      {
        mask: '(#00) 000-0000',
        definitions: {'#': /[1-9]/},
        lazy: false
      }
    ]
  }

  ngOnInit() {
    // Phone validation
    this.controls.push(new UntypedFormControl('', [Validators.required, Validators.pattern(/(\((?!000|111|200|222|300|333|400|444|500|555|600|666|700|777|900|999)\d{3}\) \d{3}-\d{4})|\d{10}/)]));
    // SMS validation
    this.controls.push(new UntypedFormControl(false));
    // Email Preference
    this.controls.push(new UntypedFormControl(false));
    // Spanish Preference
    this.controls.push(new UntypedFormControl(false));

    this.form.addControl('phone_number', this.controls[0]);
    this.form.addControl('sms', this.controls[1]);
    this.form.addControl('email_preference', this.controls[2]);
    this.form.addControl('prefers_spanish', this.controls[3]);
  }

  initStep() {
    // Give zip code focus
    setTimeout(() => this.phoneField.nativeElement.focus(), 0);
  }
}
